// Team profiles: the one source of every profile page and of the profile PDFs.
// A member is a folder under members/ with the language-independent facts in
// index.cjs and one file per language. The labels every profile shares live in
// labels/<language>.cjs. Profil/scripts/build-cv.mjs renders the PDFs from the
// same data, so page and PDF cannot drift apart.
const languages = ['de', 'en', 'nl', 'uk', 'fr', 'it', 'es', 'sv', 'fi', 'ja', 'pl', 'bg'];
const pdfLanguages = ['de', 'en'];
const contactSubject = 'Collaboration Inquiry';
// Every contact link of the homepage goes to the company address; a member's own
// address appears only in that member's PDF.
const companyEmail = require('../translations/pages/impressum/my_info.json').contact.email;

const labels = {
  de: require('./labels/de.cjs'),
  en: require('./labels/en.cjs'),
  nl: require('./labels/nl.cjs'),
  uk: require('./labels/uk.cjs'),
  fr: require('./labels/fr.cjs'),
  it: require('./labels/it.cjs'),
  es: require('./labels/es.cjs'),
  sv: require('./labels/sv.cjs'),
  fi: require('./labels/fi.cjs'),
  ja: require('./labels/ja.cjs'),
  pl: require('./labels/pl.cjs'),
  bg: require('./labels/bg.cjs')
};

// Order of the team: overview cards, navigation and profile switcher follow it.
const members = [
  require('./members/adrian-eisenmeier/index.cjs'),
  require('./members/nikolai-genov/index.cjs'),
  require('./members/alina-tselinina/index.cjs')
];

// A row appears only for a member who delivered that fact.
const personalRowOrder = [
  'name',
  'position',
  'birthdate',
  'nationality',
  'maritalStatus',
  'location',
  'languages',
  'programmingLanguages',
  'certifications',
  'publications',
  'links'
];

const pdfFileNames = (member) => Object.fromEntries(
  pdfLanguages.map((language) => [language, `${member.slug}-cv-${language}.pdf`])
);

const buildProfile = (member, language) => {
  const page = member.pages[language];
  const label = labels[language];
  // Links are language-independent facts of the member; the row carries them as
  // a list so page and PDF can render them as links.
  const links = member.links && member.links.length ? member.links : null;
  const values = { ...page.personal, name: member.name, links: links && links.map((link) => link.text).join(', ') };

  return {
    slug: member.slug,
    displayName: member.displayName,
    hero: {
      kicker: page.personal.position || '',
      title: member.displayName,
      subtitle: page.headline,
      imageAlt: page.imageAlt
    },
    summary: page.summary,
    personal: {
      title: label.personal.title,
      rows: personalRowOrder
        .filter((key) => values[key])
        .map((key) => ({ key, label: label.personal.rows[key], value: values[key], ...(key === 'links' ? { links } : {}) }))
    },
    education: { title: label.education.title, entries: page.education },
    skills: { title: label.skills.title, groups: page.skills },
    experience: { title: label.experience.title, techLabel: label.experience.techLabel, positions: page.positions },
    downloads: { ...label.downloads, files: pdfFileNames(member) },
    cta: { ...label.cta, email: companyEmail, subject: contactSubject },
    pdf: label.pdf
  };
};

const teamMembers = members.map((member) => ({
  slug: member.slug,
  displayName: member.displayName,
  name: member.name,
  pdf: member.pdf,
  pdfFiles: pdfFileNames(member),
  profiles: Object.fromEntries(languages.map((language) => [language, buildProfile(member, language)]))
}));

const getMember = (slug) => teamMembers.find((member) => member.slug === slug) || null;

// The former about page was the founder's; old links to it land on this profile.
const legacyAboutSlug = 'adrian-eisenmeier';

module.exports = {
  languages,
  pdfLanguages,
  teamMembers,
  getMember,
  legacyAboutSlug
};
